import React from "react";
import {InvoiceOrdersUIProvider} from "../components/InvoiceOrdersUIContext";
import {InvoiceOrdersLoadingDialog} from "../components/InvoiceOrdersLoadingDialog/InvoiceOrdersLoadingDialog";
import {InvoiceOrdersCard} from './InvoiceOrdersCard';

export function InvoiceOrdersPage() {
  const invoiceOrdersUIEvents = {};

  return (
    <InvoiceOrdersUIProvider invoiceOrdersUIEvents={invoiceOrdersUIEvents}>
      <InvoiceOrdersLoadingDialog />
      <InvoiceOrdersCard/>
    </InvoiceOrdersUIProvider>
  );
}
